export default __webpack_public_path__ + "static/media/Ab6.3a7e089f.mp3";